<div class="contract-row-card card-wrapper">
    <div class="card">
        <div class="head-top">&nbsp;</div>
        <ul>
            @for (item of invoiceKV; track item) {
            <li class="row">
                <div class="col-2">
                    <h5 class="title">{{ item.label | translate }}</h5>
                </div>
                <span>:</span>
                <div class="col-10">
                    @if (item?.clickable) {
                    <data>
                        <span (click)="loadContractDetail()">{{ item?.value }}</span>
                    </data>
                    } @else {
                    <data>{{ item?.value }}</data>
                    }
                </div>
            </li>
            }
        </ul>
        <por-base-button (onclick)="viewInvoicePdf()" [featureName]="'view-detail-invoice'">{{ 'View PDF' | translate }}</por-base-button>
    </div>
</div>
